
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
@Component
export default class Home extends Vue {
  resumeDataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
      filter: JSON.stringify([
        {
          fieldName: "personId",
          fieldValue: +this.$route.params.id,
        },
      ]),
    },
    className: "resume",
  });

  resumeCreateItemModel: any = {
    personId: +this.$route.params.id,
    caption: "",
  };

  doctorObjectDataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "doctor",
  });
  $message: any;

  async setDefault(id: number) {
    await this.doctorObjectDataSource.updateField({
      fieldName: "defaultResumeId",
      fieldValue: id,
    });
    this.$message("Поле успешно обновлено");
  }

  headers: any = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },
    {
      text: "Дата создания",
      value: "createDate",
      sortable: true,
    },
    {
      text: "Заголовок",
      value: "caption",
      sortable: true,
    },
    {
      text: "По умолчанию",
      value: "isDefault",
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Врачи",
        to: "/manage/doctors/",
        exact: true,
      },
      {
        text:
          this.doctorObjectDataSource.model?.fullName ??
          this.doctorObjectDataSource.model?.caption,
        to: `/manage/doctors/${+this.$route.params.id}`,
        exact: true,
      },
      {
        text: "Резюме",
        disabled: true,
      },
    ];
  }

  async created() {
    await this.doctorObjectDataSource.get();
  }
}
